import Firebase from 'firebase'
// import Firebase from 'firebase/app'
// import "firebase/app"
// import "firebase/auth"
// import "firebase/firestore"

const config = {
    apiKey: "AIzaSyC0MVOO74dATBhmsXrsj4KUEfQ-jIio9HQ",
    authDomain: "my-field-96425.firebaseapp.com",
    databaseURL: "https://my-field-96425.firebaseio.com",
    projectId: "my-field-96425",
    storageBucket: "my-field-96425.appspot.com",
    messagingSenderId: "1005291951204",
    appId: "1:1005291951204:web:afb8406c1f1cc82301fb71"
}
// var firebaseConfig = {
//     apiKey: "AIzaSyC0MVOO74dATBhmsXrsj4KUEfQ-jIio9HQ",
//     authDomain: "my-field-96425.firebaseapp.com",
//     databaseURL: "https://my-field-96425.firebaseio.com",
//     projectId: "my-field-96425",
//     storageBucket: "my-field-96425.appspot.com",
//     messagingSenderId: "1005291951204",
//     appId: "1:1005291951204:web:afb8406c1f1cc82301fb71"
//   };

const firebaseApp = Firebase.initializeApp(config, 'exercise-vue')
console.log("firebase initialized")

firebaseApp.firestore().enablePersistence().then(function(){
    console.log("firebase", "enablePersistence success")
}).catch(function(error){
    console.log("firebase", "enablePersistence failed")
})

// const messaging = firebaseApp.messaging()
// try{
//     messaging.setBackgroundMessageHandler(function(payload){
//         console.log("Message received", payload)
//     })
// } catch (error) {
//     console.log(error)
// }

// firestore.settings({ timestampsInSnapshots: true })

// function GetApplication() {
//     return this.firebaseApp
// }

export default firebaseApp
